import "./style.scss";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { StepLabel } from "@mui/material";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Stepper from "@mui/material/Stepper";
import StepConnector from "assets/img/svg/stepConnector";
import * as React from "react";

import StyledStep from "../StyledStepper";

type TProps = {
    currentStep: number;
    steps: string[];
    setCurrentStep?: any;
    setCurrentState?: any;
};

const getStepString = (step: number) => {
    switch (step) {
        case 0:
            return "first";
        case 1:
            return "second";
        case 2:
            return "third";

        default:
            break;
    }
};

function StepperComponent({ currentStep, steps, setCurrentStep, setCurrentState }: TProps) {
    const handlePreviousStep = () => {
        const step = currentStep - 1 >= 0 ? currentStep - 1 : 0;
        setCurrentStep(step);
        setCurrentState(getStepString(step));
    };

    return (
        <Box>
            <div style={{ display: "flex", gap: "6px" }}>
                {setCurrentStep && (
                    <IconButton onClick={handlePreviousStep} disabled={currentStep === 0}>
                        <ArrowBackIcon />
                    </IconButton>
                )}
                <Stepper
                    nonLinear
                    activeStep={currentStep}
                    connector={<StepConnector />}
                    sx={{ gap: "10px", justifyContent: "center" }}
                >
                    {steps.map((label, index) => (
                        <StyledStep key={label} className={index < currentStep ? "resolved" : ""}>
                            <StepLabel>{label}</StepLabel>
                        </StyledStep>
                    ))}
                </Stepper>
            </div>
        </Box>
    );
}

function areEqual(prevProps: TProps, nextProps: TProps) {
    return prevProps.currentStep === nextProps.currentStep;
}

export default React.memo(StepperComponent, areEqual);
